import { useState } from 'react';

import { BoletoView } from '../ViewsMenu/BoletoView';
import { CreditCardView } from '../ViewsMenu/CreditCardView';
import { PixView } from '../ViewsMenu/PixView';

import styles from './PurchaseMenu.module.scss';

let showAppButton: boolean;

export const PurchaseMenu = ({
  appButton,
  origin,
  paymentCards,
  isMercadoPago = false,
}) => {
  const [currentOption, setCurrenteOption] = useState('card');
  const viewOption = {
    pix: (
      <PixView
        appButton={appButton}
        origin={origin}
        isMercadoPago={isMercadoPago}
      />
    ),
    card: (
      <CreditCardView
        appButton={appButton}
        origin={origin}
        paymentCards={paymentCards}
        isMercadoPago={false}
      />
    ),
    boleto: <BoletoView origin={origin} />,
  };

  return (
    <>
      <div className={`purchase__menu ${styles['purchase__menu']}`}>
        <button
          className={`menu__item ${styles['menu__item']} ${
            currentOption === 'card' ? styles.active : ''
          } `}
          onClick={() => setCurrenteOption('card')}
        >
          <p>Cartão</p>
          <span>Até 3x</span>
        </button>

        <button
          className={`menu__item ${styles['menu__item']} ${
            currentOption === 'pix' ? styles.active : ''
          } `}
          onClick={() => setCurrenteOption('pix')}
        >
          <p>Pix</p>
          <span>à vista</span>
        </button>

        <button
          className={`menu__item ${styles['menu__item']} ${
            currentOption === 'boleto' ? styles.active : ''
          } `}
          onClick={() => setCurrenteOption('boleto')}
        >
          <p>Boleto</p>
          <span>à vista</span>
        </button>
      </div>
      <div
        className={`purchase__option__view ${styles['purchase__option__view']}`}
      >
        {viewOption[currentOption]}
      </div>
    </>
  );
};
